import React, { useEffect, useRef, useState } from 'react'
import FileUploadButton from './FileUploadButton'
import deleteImage from '../../../assets/delete-image.svg';
import customToast from '../../../components/common/basic/Toast';
import { ErrMessages } from '../../EventInfo/config/error-constants';
import { isImageFile, JS_TYPES } from '../../../reusable/common';
import { FilePreview } from 'kh-design-system/components';
import { cutString } from "../../../services/util";


const UploadFiles = ({ getUploadedFiles, formik, isEdit ,loading }) => {
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);

    const handleButtonClick = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const MAX_FILE_SIZE = 15 * 1024 * 1024; 
    const MAX_FILES = 10;
    const allowedExtensions = /\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx|ppt|pptx|zip)$/i;
    
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
            const validFiles = selectedFiles.filter(file => {
            if (!allowedExtensions.test(file.name)) {
                customToast.error(`"${file.name}" is not a valid file type.`);
                return false;
            }
            if (file.size > MAX_FILE_SIZE) {
                customToast.error(`"${file.name}" exceeds the 15MB file size limit.`);
                return false;
            }
            return true;
        });
            if (files.length + validFiles.length > MAX_FILES) {
            customToast.error(ErrMessages.MAXIMUM_LIMIT_MESSAGE);
            return;
        }
        const updatedFiles = [...files, ...validFiles];
        setFiles(updatedFiles);
        getUploadedFiles(updatedFiles);
        e.target.value = null;
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = formik.values.files.filter((_, i) => i !== index);
        formik.setFieldValue("files", updatedFiles);
        setFiles(updatedFiles);
    };
    const downloadFile = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {
            const initialFiles = formik?.values?.files || [];
            setFiles(initialFiles);
    });


    return (
        <div className='w-100'>
            <div className="d-flex mt-2 align-items-start justify-content-between col-12 mt-4 pt-1">
                <div
                    className="d-flex flex-column upload-main-container"
                >
                    <div>
                        <p className='task-form-input-title'>Upload Supporting Files</p>
                        <p className='task-form-input-subtitle'>
                        Only image, PDF, Word, Excel, ZIP , and PowerPoint files are accepted, with a size limit of 15 MB per file. The maximum number of files allowed for upload is 10.
                        </p>

                    </div>

                </div>
                <div>
                    <FileUploadButton handleRemoveFile
                        handleFileChange={handleFileChange}
                        handleButtonClick={handleButtonClick}
                        fileInputRef={fileInputRef}
                        setFiles={setFiles}
                        loading={loading}

                        getUploadedFiles={getUploadedFiles} />
                </div>
            </div>
            <div className="uploaded-files mb-3 task-add-edit ">
            {files.map((file, index) => {                            
                            return (
                                <div className='task-file-item d-flex flex-column text-center'>
                                <FilePreview
                                key={file.url}
                                url={file.url}
                                onDelete={() => handleRemoveFile(index)}
                                containerStyle={{
                                    width: '145px',
                                    height: '100px',
                                    margin: '10px'
                                }}
                                deleteIconColor="red"
                                showDeleteButton={true}
                                isImage={isImageFile(file.url)} 
                                showBoth={true}
                                showDownloadButton={true}
                                handleDownload={(e) => {
                                        e.preventDefault();
                                        downloadFile(file.url);
                                    }}
                                downloadIconColor="#572148"
                                />  
                            {cutString(file?.file_name ?? '', 15)}
                            </div>
                            );
                            })}
                    </div>
            <style jsx>
                {`
                    .file-item{
                    border: 1.3px solid #C3CDDF;
                        color:#007BFF;
                        font-size:14px;
                    }
                    .task-file-item{
                        color:#007BFF;
                        font-size:14px;
                    }
                    .upload-main-container {
                       max-width:600px;
                    }
                    .task-form-input-title{
                        color:#572148;
                        margin-bottom: 5px;
                    }
                    .task-form-input-subtitle{
                        color:#333333;
                        font-size:14px;
                        font-weight:400;
                    }
                    .uploaded-files{
                        padding: 4px 9px ;
                    }
                  .task-add-edit  .file-icon-preview{
                        border-radius: 8px !important;
                    }
                
                `}
            </style>
        </div>
    )
}

export default UploadFiles